import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";

const EMAILS = [
  { name: "Clémence Terrier", email: "clemence@troiscouronnesproductions.com", id: "clemence-terrier" },
  { name: "Baptiste Lorber", email: "baptiste@troiscouronnesproductions.com", id: "baptiste-lorber" },
  { name: "Nabiha Akkari", email: "nabiha@troiscouronnesproductions.com", id: "nabiha-akkari" },
];

export default function Contact() {
  const { t } = useLanguage();
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative pt-24 md:pt-36 pb-12 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20"
        >
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#C5A059]" />
              <span className="tcp-eyebrow">{t.contact.eyebrow}</span>
            </div>
            <h2 className="font-display text-[#F5F5F0] text-4xl sm:text-5xl md:text-6xl leading-[1.05]">
              {t.contact.title}
            </h2>
            <p className="mt-6 max-w-md text-[#A3A3A3] text-base leading-relaxed">
              {t.contact.description}
            </p>
          </div>

          <div className="md:col-span-7 flex flex-col justify-center">
            <div className="space-y-10 md:space-y-12">
              {EMAILS.map((p) => (
                <div key={p.email} className="border-t border-white/10 pt-7">
                  <div className="text-[11px] tracking-[0.32em] uppercase text-[#9c9b94] mb-3">
                    {p.name}
                  </div>
                  <a
                    href={`mailto:${p.email}`}
                    data-testid={`contact-email-${p.id}`}
                    className="group inline-flex items-center gap-4 text-[#F5F5F0] hover:text-[#C5A059] transition-colors"
                  >
                    <span className="font-display text-lg sm:text-xl md:text-2xl leading-tight tracking-tight tcp-link whitespace-nowrap">
                      {p.email}
                    </span>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </motion.div>

        <div className="mt-28 md:mt-36 flex flex-col items-center text-center">
          <img
            src="/logo.png"
            alt="Trois Couronnes Productions"
            className="h-24 w-24 md:h-28 md:w-28 object-contain opacity-90"
            data-testid="footer-logo"
          />
          <div className="mt-6 font-display text-2xl md:text-3xl text-[#F5F5F0] tracking-tight">
            Trois Couronnes
            <span className="block text-[10px] tracking-[0.4em] uppercase text-[#9c9b94] mt-2">
              Productions
            </span>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] tracking-[0.2em] uppercase text-[#6f6e68]">
          <span data-testid="footer-copyright">
            © {new Date().getFullYear()} Trois Couronnes Productions — {t.contact.copyright}
          </span>
          <div className="flex items-center gap-5">
            <Link
              to="/mentions-legales"
              data-testid="footer-legal-link"
              className="tcp-link hover:text-[#F5F5F0] transition-colors"
            >
              {t.contact.legalLink}
            </Link>
            <span>{t.contact.location}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
